import { Auth0Provider } from '@auth0/auth0-react'
import { LicenseInfo } from '@mui/x-data-grid-pro'
import type { AppProps } from 'next/app'
import Script from 'next/script'
import { ReactNode } from 'react'
import Layout from '../components/Layout'
import { AbilityContext } from '../lib/can'
import { useAbility } from '../lib/hooks/api'
import '../style/style.css'

const AbilityComponent = ({ children }: { children: ReactNode }) => {
  const { ability } = useAbility()

  return (
    <AbilityContext.Provider value={ability}>
      {children}
    </AbilityContext.Provider>
  )
}

const App = ({ Component, pageProps }: AppProps) => {
  LicenseInfo.setLicenseKey(
    '569f078404006dc34e94b620f8573a86T1JERVI6MzIxNTUsRVhQSVJZPTE2Njc4NTg2NTkwMDAsS0VZVkVSU0lPTj0x',
  )

  return (
    <>
      <Script
        src="https://browser.sentry-cdn.com/6.17.2/bundle.min.js"
        integrity="sha384-WkFzsrcXKeJ3KlWNXojDiim8rplIj1RPsCbuv7dsLECoXY8C6Cx158CMgl+O+QKW"
        crossOrigin="anonymous"
      />

      <Auth0Provider
        domain={process.env.NEXT_PUBLIC_AUTH0_DOMAIN as string}
        clientId={process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID as string}
        redirectUri={
          (typeof window !== 'undefined' && window.location.origin) || ''
        }
        useRefreshTokens={true}
        audience={process.env.NEXT_PUBLIC_AUTH0_AUDIENCE as string}
      >
        <AbilityComponent>
          {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            Layout(<Component {...pageProps} />, pageProps)
          }
        </AbilityComponent>
      </Auth0Provider>
    </>
  )
}

export default App
